import React, { Component } from 'react';
import { FormGroup, Row, Col, Grid, ControlLabel } from 'react-bootstrap';
import { connect } from 'react-redux';
import { Form, actions } from 'react-redux-form';
import ArrowButton from '../common/button-arrow';
import Select from '../common/form/elements/select';
import Datepicker from '../common/form/datepicker';

class Filter extends Component {
  getFilterData = () => {
    const { form } = this.props;

    return {
      outlet_id: form.outlet_id.value,
      transaction_type: form.transaction_type.value,
      date_from: form.date_from.value,
      date_to: form.date_to.value,
    }
  };

  handleClearFilters = () => {
    const { dispatch } = this.props;

    dispatch(actions.reset('deep.points_statement'));
    this.handleSubmit();
  };

  handleSubmit = () => {
    const { applyFilters } = this.props;

    applyFilters(this.getFilterData());
  };

  handleDownload = () => {
    const { download } = this.props;

    download();
  };

  getStoreOptions = () => {
    const { stores } = this.props;

    return [].concat(...stores.map(outlets => {
      return {value: outlets.attributes['customer-number'], label: outlets.attributes.name}
     }));
  };

  transactionTypes = [
    { value: 'credit', label: 'Credit' },
    { value: 'debit', label: 'Debit' },
  ];

  render() {
    const { form } = this.props;

    if (form === undefined) {
      return null;
    }

    return (
      <Grid fluid>
        <Form
          model='deep.points_statement'
          onSubmit={this.handleSubmit}
        >
          <Row>
            <Col xs={12} className="download-transactions-button">
              <ArrowButton arrow={false} onClick={this.handleDownload}>Download all transactions</ArrowButton>
            </Col>
            <Col xs={12}>
              <FormGroup controlId="outlet_id">
                <Select values={this.getStoreOptions()}
                        label="Store"
                        model="deep.points_statement.outlet_id"
                        emptyValue="Select a store..."
                        emptyValueDisabled={false}
                        selectedValue={form.outlet_id.value}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <FormGroup controlId="transaction_type">
                <Select values={this.transactionTypes}
                        label="Transaction type"
                        model="deep.points_statement.transaction_type"
                        emptyValue="All"
                        emptyValueDisabled={false}
                        selectedValue={form.transaction_type.value}
                />
              </FormGroup>
            </Col>
            <Col xs={12}>
              <ControlLabel>Date range</ControlLabel>
              <Row>
                <Col xs={5}>
                  <Datepicker
                    model="deep.points_statement.date_from"
                    controlId="date_to"
                    value={form.date_from.value}
                  />
                </Col>
                <Col xs={2} className="date-to-text">to</Col>
                <Col xs={5}>
                  <Datepicker
                    model="deep.points_statement.date_to"
                    controlId="date_to"
                    value={form.date_to.value}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row>
            <Col xs={12}>
              <Row className="pull-right">
                <Col sm={6}>
                  <ArrowButton arrow={false} submit>Apply filters</ArrowButton>
                </Col>
                <Col sm={6}>
                  <ArrowButton arrow={false} onClick={this.handleClearFilters}>Clear</ArrowButton>
                </Col>
              </Row>
            </Col>
          </Row>
        </Form>
      </Grid>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    form: state.deep.forms.points_statement
  };
};

export default connect(mapStateToProps)(Filter);



// WEBPACK FOOTER //
// ./src/components/points-statement/filter.jsx